function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export const DateColorful = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 8.90541V18.0946C22 21.3378 20.3333 23.5 16.4444 23.5H7.55556C3.66667 23.5 2 21.3378 2 18.0946V8.90541C2 5.66216 3.66667 3.5 7.55556 3.5H16.4444C20.3333 3.5 22 5.66216 22 8.90541Z",
  fill: "#C3B3FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 11.75H8C7.59 11.75 7.25 11.41 7.25 11C7.25 10.59 7.59 10.25 8 10.25H16C16.41 10.25 16.75 10.59 16.75 11C16.75 11.41 16.41 11.75 16 11.75Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 16.75H8C7.59 16.75 7.25 16.41 7.25 16C7.25 15.59 7.59 15.25 8 15.25H12C12.41 15.25 12.75 15.59 12.75 16C12.75 16.41 12.41 16.75 12 16.75Z",
  fill: "#6942F8"
}));